import React, { useSyncExternalStore } from 'react'
import { AuthContext } from 'hooks/auth'
import { getCurrentUser, getMasqueradeToken } from 'helpers/auth'
import { subscribeToCredentialChanges } from 'hooks/useSocketCredentialSync'

// Who's reading: the account, and the one it's masquerading as, if any.
const viewer = (): string => `${getCurrentUser()?.publicId ?? ''}|${getMasqueradeToken() ?? ''}`

/**
 * Who's reading, for keying what depends on what they may see. Kept current as a masquerade starts or ends or
 * another tab signs in (their events), and as this tab signs in or out (the auth context, read without requiring
 * one, so a component outside it still has a viewer).
 */
export const useViewer = (): string => {
  React.useContext(AuthContext)
  return useSyncExternalStore(subscribeToCredentialChanges, viewer)
}
